export const base_url = "https://bjpodisha.org/karyalays/";
